import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_EV_DEMO_USE_CASE_5_DEMO_VIDEO = {
  videoSrc: "EV/Use_case_5_demo.mp4",
  title: "GEN AI-BASED CALL CENTER AGENT TRAINING: DEMO VIDEO",
  onClose: () => setCurrentPage(416),
};

export default DATA_EV_DEMO_USE_CASE_5_DEMO_VIDEO;
